import {email, helpers} from "vuelidate/lib/validators";

export const phone = helpers.regex('phone', /^09[0-9]{9}$/)
export const telphone = helpers.regex('telphone', /^[0-9]{11}$/)
export const postalcode = helpers.regex('postalcode', /^[0-9]{10}$/)
export const emailOrPhone = (value) => email(value) || phone(value)

export const slug = helpers.regex('slug', /^\S*$/)
export const phoneStartWith98 = helpers.regex('alpha', /(\+98)[0-9]{10}/);